<script lang="ts" setup>
export type AlertColors = 'success' | 'error' | 'info' | 'warning'
export type AlertVariant = 'default' | 'light'

export interface AlertProps {
    color?: AlertColors
    variant?: AlertVariant
    dismissible?: boolean
}

const props = withDefaults(defineProps<AlertProps>(), {
    color: 'success',
    variant: 'default',
    dismissible: false,
})

const visible = ref(true)
</script>

<template>
  <div
    v-if="visible"
    role="alert"
    class="alert d-flex rounded-3 p-3 fs-small"
    :class="[
      `alert-${props.color}`,
      { 'alert-light': props.variant === 'light' },
      {'has-close-button': props.dismissible},
    ]"
  >
    <div class="flex-grow-1 d-flex flex-row justify-content-center">
      <slot />
    </div>

    <button
      v-if="props.dismissible"
      type="button"
      class="alert-close flex-shrink-0 ms-3"
      aria-label="Zavrieť"
      @click="visible = false"
    >
      <svg
        class="d-block"
        width="11"
        height="11"
        aria-hidden="true"
      >
        <use xlink:href="#cross-small" />
      </svg>
    </button>
  </div>
</template>

<style>
@import './Alert.vars.scss';
</style>
<style scoped>
@import './Alert.scss';
</style>
